// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "2931") return "2931.0ead09100.bundle.js";
if (chunkId === "6633") return "6633.0ead09100.bundle.js";
  // return url for filenames based on template
  return "" + chunkId + ".0ead09100.chunk.js"
}